import { createCategories } from '../../../actions/management/methods/create-categories'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Saves new categories
 * @param {string|number} assetId - The asset ID
 * @param {Array} categories - The categories to create
 * @param {Function} i18n - Translation function
 * @returns {Object} - Result with success status
 */
export const saveCategories = async (assetId, categories, i18n) => {
  try {
    const result = await createCategories(assetId, categories)
    
    const successMessage = i18n ? i18n('settings.components.configuration.components.categoryModal.common.success.created') : 'Categories created successfully'
    responseHandlerService.handleSuccess(successMessage)
    
    return { success: true, data: result }
  } catch (error) {
    responseHandlerService.handleError(error)
    return { success: false, error }
  }
}
